import { Nullable } from '@homeserve/od-typings/utils';
import { AsYouType } from 'libphonenumber-js';
import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js/mobile';
import { Validator } from 'vee-validate';

interface ICountryCodeParam {
  countryCode: CountryCode;
}

export const paramNames = ['countryCode'];

export default function isValidPhoneNumber(value: Nullable<string>, args: object | any[]): boolean {
  if (!value) {
    return false;
  }

  const { countryCode = 'FR' } = args as ICountryCodeParam;
  const phoneNumber = parsePhoneNumberFromString(value, countryCode);

  if (!phoneNumber || !phoneNumber.isValid()) {
    return false;
  }

  const maxLength = new AsYouType(countryCode).input(value).replace(/\s/g, '').length;

  return value.replace(/\s/g, '').length === maxLength;
}

Validator.extend('phone', isValidPhoneNumber, {
  paramNames,
});
